<template>
    <div class="sportFootballMatchstatusPeriodOffset">
      <span>{{ offset }}</span>
    </div>
</template>

<script>
import { stopwatch } from '@/helpers/format'

export default {
  name: 'SportFootballMatchStatusPeriodOffset',
  props: {
    start: Date,
    end: Date
  },
  computed: {
    offset () {
      return stopwatch(this.start, this.end, 7)
    }
  }
}
</script>

<style>
.sportFootballMatchstatusPeriodOffset{
  position:relative
}
.sportFootballMatchstatusPeriodOffset span{
  position:relative;
  display:inline-block;
  height:25px;
  line-height:25px;
  border:none;
  background-color:var(--color-background-offset);
  color:var(--color-font-offset);
  border-radius:12px;
  padding:0 10px;
  text-align: center;
  width:auto;
  font-size:14px;
}
</style>
